const validateFein = (fein: string): boolean =>
  !!(fein && fein.length === 9 && !Number.isNaN(Number(fein)));

export default validateFein;
